import { createSlice } from '@reduxjs/toolkit';
import { fetchStepById } from './actions';

const initialState = {
  data: {},
};

const { reducer } = createSlice({
  name: 'step',
  initialState,

  reducers: {},

  extraReducers: {
    [fetchStepById.pending]: (state, { meta }) => {
      const { stepId } = meta?.arg;
      state.data[stepId] = { isLoading: true };
    },
    [fetchStepById.fulfilled]: (state, { meta, payload }) => {
      const { stepId } = meta?.arg;
      state.data[stepId] = { ...payload.data, isLoading: false };
    },
  },
});

export default reducer;
